import { combineReducers } from 'redux';

import cart from './cart';
import user from './user';
import order from './order';
import product from './product';
import address from './address';
import coupon from './coupon';
import group from './group';
import special from './special';
import popup from './popup';
import guide from './guide';
import moment from './moment';
import appoint from './appoint';
import ar from './ar';

export default combineReducers({
  cart,
  user,
  order,
  product,
  address,
  coupon,
  group,
  special,
  popup,
  guide,
  moment,
  appoint,
  ar,
});
